import { type InputHTMLAttributes, type ReactNode, type SelectHTMLAttributes, useId } from "react";
import { cn } from "@/lib/utils";

const control =
  "min-h-11 w-full rounded-chip border border-border bg-surface px-3 text-[15px] text-ink placeholder:text-muted " +
  "focus-visible:border-accent focus-visible:outline-2 focus-visible:outline-accent/30 " +
  "disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-expense";

/** Rótulo + controle + dica, ligados por id. */
export function Field({
  label,
  hint,
  children,
}: {
  label: string;
  hint?: string;
  children: (id: string) => ReactNode;
}) {
  const id = useId();
  return (
    <div className="flex min-w-0 flex-col gap-1.5">
      <label htmlFor={id} className="text-sm font-medium text-ink">
        {label}
      </label>
      {children(id)}
      {hint && <p className="m-0 text-xs text-muted">{hint}</p>}
    </div>
  );
}

export function TextInput({
  label,
  hint,
  className,
  ...props
}: InputHTMLAttributes<HTMLInputElement> & { label: string; hint?: string }) {
  return (
    <Field label={label} hint={hint}>
      {(id) => <input id={id} {...props} className={cn(control, className)} />}
    </Field>
  );
}

export function Select({
  label,
  children,
  className,
  ...props
}: SelectHTMLAttributes<HTMLSelectElement> & { label: string; children: ReactNode }) {
  return (
    <Field label={label}>
      {(id) => (
        <select id={id} {...props} className={cn(control, "pr-8", className)}>
          {children}
        </select>
      )}
    </Field>
  );
}
